import { COLOR } from "../../../../common/Color"
import { FBTimestampNow } from "../../../../common/FirebaseConfig"
import { FontType } from "../../../../common/TextUtils"
import { StudentStoreSA } from "../../../../react/students/StudentStoreSA"
import { PhaserText } from "../../../utils/PhaserText"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { PlaygroundStore } from "../PlaygroundStore"
import { PlaygroundPromise } from "../PlaygroundType"

export class KidPromise {
    promiseText: Phaser.Text
    usernameText: Phaser.Text
    stickerSprite: Phaser.Sprite

    style: string
    color: string
    sprite: string

    constructor(private game: Phaser.Game, private group: Phaser.Group) {}

    static createPromiseText = (
        game: Phaser.Game,
        group: Phaser.Group,
        selected: string,
        color: string = COLOR.white,
        style: string = FontType.BODY,
        x: number = Scale.x(0.6),
        y: number = Scale.y(0.35),
        fontPx = 24,
        wordWrapWidth = 0.3,
    ): Phaser.Text =>
        PhaserText.create(game, selected, {
            x,
            y,
            group,
            color,
            fontPx,
            wordWrapWidth,
            type: style as FontType,
        })

    static createStickerSprite = (
        game: Phaser.Game,
        group: Phaser.Group,
        selected: string,
        x: number,
        y: number,
        scale = 1,
    ): Phaser.Sprite => Sprites.add(game, selected, { x, y, group, scale })

    static usernameY = (y: number, height: number): number =>
        y + height + Scale.y(0.02)

    static stickerX = (x: number, width: number): number =>
        x + width + Scale.x(0.01)

    get selectedText(): string {
        return this.promiseText ? this.promiseText.text : ""
    }

    set selectedText(selected: string) {
        this.createPromisePhrase(selected)
    }

    set selectedStyle(selected: string) {
        this.style = selected
        this.createPromisePhrase(this.selectedText)
    }

    set selectedColor(selected: string) {
        this.color = selected
        this.createPromisePhrase(this.selectedText)
    }

    set selectedUsername(selected: string) {
        if (this.usernameText) {
            this.usernameText.destroy()
        }
        const usernameY = KidPromise.usernameY(
            this.promiseText.y,
            this.promiseText.height,
        )
        this.usernameText = KidPromise.createPromiseText(
            this.game,
            this.group,
            `- ${selected}`,
            this.color,
            this.style,
            this.promiseText.x,
            usernameY,
        )
    }

    set selectedSprite(selected: string) {
        this.sprite = selected

        if (this.stickerSprite) {
            this.stickerSprite.destroy()
        }

        const x = KidPromise.stickerX(
            this.usernameText.x,
            this.usernameText.width,
        )
        const y = KidPromise.usernameY(
            this.promiseText.y,
            this.promiseText.height,
        )
        this.stickerSprite = KidPromise.createStickerSprite(
            this.game,
            this.group,
            selected,
            x,
            y,
        )
    }

    replacePhrase = () => {
        if (this.promiseText) {
            this.createPromisePhrase(this.selectedText)
        }
    }

    savePromise = () => {
        const promise: PlaygroundPromise = {
            promise: this.selectedText,
            style: this.style,
            color: this.color,
            sticker: this.sprite,
            screenname: StudentStoreSA.instance.student
                ? StudentStoreSA.instance.student.screenname
                : "Unknown",
            date: FBTimestampNow(),
        }

        PlaygroundStore.instance.savePromise(promise)
    }

    destroy = () => {
        this.promiseText.destroy()
        this.usernameText.destroy()
        this.stickerSprite.destroy()
    }

    centerPhrase = () => {
        this.createPromisePhrase(
            this.selectedText,
            Scale.x(0.35),
            Scale.y(0.4),
            this.usernameText.text,
        )
    }

    private static get username(): string {
        return `- ${
            StudentStoreSA.instance.student
                ? StudentStoreSA.instance.student.screenname
                : "undefined"
        }`
    }

    private createPromisePhrase = (
        selected: string,
        x?: number,
        y?: number,
        username: string = KidPromise.username,
    ) => {
        if (this.promiseText) {
            this.promiseText.destroy()
        }

        if (x && y) {
            this.promiseText = KidPromise.createPromiseText(
                this.game,
                this.group,
                selected,
                this.color,
                this.style,
                x,
                y,
            )
        } else {
            this.promiseText = KidPromise.createPromiseText(
                this.game,
                this.group,
                selected,
                this.color,
                this.style,
            )
        }

        if (this.usernameText) {
            this.usernameText.destroy()
        }

        const usernameY = KidPromise.usernameY(
            this.promiseText.y,
            this.promiseText.height,
        )
        this.usernameText = KidPromise.createPromiseText(
            this.game,
            this.group,
            username,
            this.color,
            this.style,
            this.promiseText.x,
            usernameY,
        )

        if (this.stickerSprite) {
            const stickerX = KidPromise.stickerX(
                this.usernameText.x,
                this.usernameText.width,
            )
            this.stickerSprite.destroy()
            this.stickerSprite = KidPromise.createStickerSprite(
                this.game,
                this.group,
                this.sprite,
                stickerX,
                usernameY,
            )
        }
    }
}
